import React from 'react'

export default function Button() {
    return (
        
            <div className="d-grid">
                <a href="/" className="btn btn-primary text-uppercase">Button</a>
            </div>
       
    )
}
